a.fp-link.-no-text-decoration(:href='club.webappUrl' rel='noreferrer')
  .fp-decorated-listing-element
    .fp-decorated-listing-element--logo
      FairplayerImageVue(:url='club.logoUrl' :resolution='ImageResolution.SM' :alt='`${club.name} logo`' :fallback-image='FairplayerFallbackImageUi.LOGO')
    .fp-decorated-listing-element--text
      span.fp-text.-text-md {{ t('linkedClub.interestedBy') }}
      span.fp-text.-text-2xl.-text-semi-bold(:data-test='`linked-club.${club.slug}.name`') {{ t('linkedClub.discover', { club: club.platformName }) }}
    .fp-decorated-listing-element--banner
      FairplayerImageVue(:url='club.bannerUrl' :resolution='ImageResolution.SM' :alt='`${club.name} banner`' :fallback-image='FairplayerFallbackImageUi.BANNER')
